// extracted by mini-css-extract-plugin
export var alt = "LoginForm-module--alt--8a55a";
export var checkoutTitle = "LoginForm-module--checkoutTitle--204f6";
export var desktopOnly = "LoginForm-module--desktopOnly--8a589";
export var formContainer = "LoginForm-module--form-container--8f380";
export var formGroup = "LoginForm-module--formGroup--bf72b";
export var hide = "LoginForm-module--hide--42c6c";
export var main = "LoginForm-module--main--f954f";
export var mobileOnly = "LoginForm-module--mobileOnly--18ceb";
export var show = "LoginForm-module--show--82cf5";
export var styledForm = "LoginForm-module--styledForm--641e8";
export var styledFormCheckout = "LoginForm-module--styledFormCheckout--c25ae";
export var textLeft = "LoginForm-module--textLeft--97c03";
export var title = "LoginForm-module--title--239bd";
export var title1 = "LoginForm-module--title1--b489c";
export var visuallyHidden = "LoginForm-module--visuallyHidden--50af8";
export var welcomeBlock = "LoginForm-module--welcomeBlock--af18b";